function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React from "react";
import { withRouter } from "react-router";
import { Link } from "react-router-dom";
import { Card, Empty, Search, Filters, PlunkDropDown, Pill } from "../../components/analytics-kit";
import { Loader } from "../../components/loaders";
import Error from "../../components/error";
import { Modal } from "../audiences/ui";
import { listOrders, getOrder, cancelOrder, ORDER_STATUSES, orderStatusLabel, orderStatusTone } from "../sales/sales-quotes-api";
import { QuotesGate, QuotesShell, Btn, Notice, money, money0, fmtDate, fmtDateTime, relTime, businessDaysSince, errText } from "./common";

/*
 * Orders tab (SALES_QUOTES_ORDER_DESK.md §7 rule 9, mockup E): order requests
 * with status chips and the ERP timeline built from the status events
 * (POST /cx/v1/ingest/order-status writes one event per report). A request
 * stuck in pending_erp for more than two business days is flagged.
 *
 *   /Quotes/orders        the list; the first row's timeline opens on the right
 *   /Quotes/orders/:id    the same page with that request selected
 */
// The request's own statuses, in order; cancelled and on_hold render as extra rows where they happen.
const TIMELINE = ["pending_erp", "received", "acknowledged", "in_production", "partially_shipped", "shipped", "invoiced"];
const STEP_LABEL = {
  pending_erp: "Accepted, pending ERP",
  received: "Received by ERP",
  acknowledged: "Acknowledged",
  in_production: "In production",
  partially_shipped: "Partially shipped",
  shipped: "Shipped",
  invoiced: "Invoiced"
};
class OrdersView extends React.Component {
  constructor(props) {
    super(props);
    _defineProperty(this, "open", r => {
      if (this.selId() !== r.id) this.props.history.push(`/Quotes/orders/${encodeURIComponent(r.id)}`);else this.select(r.id);
    });
    _defineProperty(this, "cancel", async () => {
      const {
        sel,
        cancelReason
      } = this.state;
      if (!sel || !cancelReason.trim()) return;
      this.setState({
        busy: true
      });
      try {
        await cancelOrder(sel.id, cancelReason.trim());
        if (!this._alive) return;
        const upd = {
          ...sel,
          status: "cancelled"
        };
        this.setState({
          busy: false,
          modal: null,
          sel: upd,
          rows: (this.state.rows || []).map(r => r.id === sel.id ? upd : r),
          notice: {
            tone: "info",
            text: `${sel.number || "Request"} cancelled.`
          }
        });
      } catch (e) {
        if (this._alive) this.setState({
          busy: false,
          modal: null,
          notice: {
            tone: "danger",
            text: errText(e, "The request could not be cancelled here. After the ERP acknowledges, cancel it in the ERP.")
          }
        });
      }
    });
    const sp = new URLSearchParams(props.location && props.location.search || "");
    this.state = {
      rows: undefined,
      error: false,
      chip: sp.get("status") || "all",
      dealer: sp.get("customerId") || "",
      q: "",
      sel: undefined,
      selBusy: false,
      notice: null,
      modal: null,
      cancelReason: "",
      busy: false
    };
    this._alive = true;
  }
  selId() {
    const id = this.props.params && this.props.params.id;
    return id ? decodeURIComponent(id) : "";
  }
  componentDidMount() {
    this.load();
  }
  componentWillUnmount() {
    this._alive = false;
  }
  componentDidUpdate(prev) {
    if ((prev.params && prev.params.id) !== (this.props.params && this.props.params.id)) this.select(this.selId());
  }
  load() {
    listOrders().then(rows => {
      if (!this._alive) return;
      this.setState({
        rows
      });
      const id = this.selId() || rows && rows[0] && rows[0].id;
      if (id && rows) this.select(id, rows);
    }).catch(() => this._alive && this.setState({
      error: true
    }));
  }
  select(id, rows) {
    const list = rows || this.state.rows || [];
    const row = list.find(r => r.id === id) || null;
    this.setState({
      sel: row,
      selBusy: !!id
    });
    if (!id) return;
    getOrder(id).then(or => this._alive && this.setState({
      sel: or || row,
      selBusy: false
    })).catch(() => this._alive && this.setState({
      selBusy: false
    }));
  }
  filtered() {
    const {
      rows,
      chip,
      dealer,
      q
    } = this.state;
    const t = q.trim().toLowerCase();
    return (rows || []).filter(r => (chip === "all" || r.status === chip) && (!dealer || r.customerId === dealer) && (!t || `${r.number} ${r.customerName} ${r.erpOrderId} ${r.poNumber} ${r.quoteNumber}`.toLowerCase().includes(t)));
  }
  stuck(r) {
    return r.status === "pending_erp" && businessDaysSince(r.createdDate) > 2;
  }
  noteFor(r) {
    if (this.stuck(r)) return `${businessDaysSince(r.createdDate)} business days · flagged`;
    if (r.status === "acknowledged" && r.requestedDate) return `requested ${fmtDate(r.requestedDate, false)}`;
    if (r.statusNote) return r.statusNote;
    const ships = (r.events || []).reduce((a, e) => a + (e.shipments || []).length, 0);
    if (ships > 1) return `${ships} shipments`;
    return "";
  }
  timeline(or) {
    const events = (or.events || []).slice().sort((a, b) => String(a.statusDate).localeCompare(String(b.statusDate)));
    const byStatus = {};
    events.forEach(e => {
      byStatus[e.status] = e;
    });
    const reached = TIMELINE.indexOf(or.status);
    const extra = events.filter(e => !TIMELINE.includes(e.status));
    const terminal = ["cancelled", "on_hold"].includes(or.status);
    const rows = TIMELINE.map((s, i) => {
      const ev = byStatus[s];
      const done = s === "pending_erp" ? true : ev ? true : reached >= 0 && i <= reached;
      const now = s === or.status;
      let detail = "";
      if (s === "pending_erp") detail = [or.createdDate ? fmtDate(or.createdDate, false) : null, or.acceptedBy || or.createdBy || null, or.poNumber ? `PO ${or.poNumber}` : null, money0(or.totalNet), or.status === "pending_erp" ? "waiting for the ERP's first report" : null].filter(Boolean).join(" · ");else if (ev) {
        const ships = (ev.shipments || []).map(sh => `${sh.carrier || "carrier"}${sh.tracking ? ` ${sh.tracking}` : ""}`).join(", ");
        const lines = (ev.lines || []).filter(l => l.shipped != null || l.backordered).map(l => `${l.productId}: ${l.shipped || 0} of ${l.ordered || "?"}${l.backordered ? ` · ${l.backordered} backordered${l.eta ? ` ETA ${fmtDate(l.eta, false)}` : ""}` : ""}`).join("; ");
        detail = [ev.statusDate ? fmtDate(ev.statusDate, false) : null, s === "received" && or.erpOrderId ? `${or.erpOrderId} linked` : null, ships || null, lines || null, ev.note || null].filter(Boolean).join(" · ");
      } else if (!done) detail = terminal ? "" : s === "invoiced" ? "pending · flips the sales rows to invoiced" : "pending";
      return {
        s,
        done,
        now,
        detail
      };
    });
    return /*#__PURE__*/React.createElement("div", {
      className: "qt-timeline"
    }, rows.map(r => /*#__PURE__*/React.createElement("div", {
      className: `ev${r.done ? " done" : ""}${r.now ? " now" : ""}`,
      key: r.s
    }, /*#__PURE__*/React.createElement("i", null), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("b", null, STEP_LABEL[r.s]), /*#__PURE__*/React.createElement("span", null, r.detail)))), extra.map(e => /*#__PURE__*/React.createElement("div", {
      className: `ev other${e.status === or.status ? " now" : ""}`,
      key: e.id || e.status + e.statusDate
    }, /*#__PURE__*/React.createElement("i", null), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("b", null, orderStatusLabel(e.status)), /*#__PURE__*/React.createElement("span", null, [e.statusDate ? fmtDate(e.statusDate, false) : null, e.note].filter(Boolean).join(" · "))))), terminal && !extra.some(e => e.status === or.status) ? /*#__PURE__*/React.createElement("div", {
      className: "ev other now"
    }, /*#__PURE__*/React.createElement("i", null), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("b", null, orderStatusLabel(or.status)), /*#__PURE__*/React.createElement("span", null, [or.statusDate ? fmtDate(or.statusDate, false) : null, or.statusNote].filter(Boolean).join(" · ")))) : null);
  }
  render() {
    const {
      rows,
      error,
      chip,
      dealer,
      q,
      sel,
      selBusy,
      notice,
      modal,
      cancelReason,
      busy
    } = this.state;
    if (error) return /*#__PURE__*/React.createElement(Error, null);
    const list = rows ? this.filtered() : [];
    const counts = {};
    (rows || []).forEach(r => {
      counts[r.status] = (counts[r.status] || 0) + 1;
    });
    const dealers = Array.from(new Map((rows || []).map(r => [r.customerId, r.customerName || r.customerId])).entries());
    const lastReport = (rows || []).reduce((a, r) => r.statusDate && (!a || r.statusDate > a) ? r.statusDate : a, null);
    // Cancel is possible until the ERP acknowledges (owners, administrators and the request's own sales user; the server enforces ownership).
    const canCancel = sel && ["pending_erp", "received"].includes(sel.status);
    return /*#__PURE__*/React.createElement(QuotesGate, null, /*#__PURE__*/React.createElement(QuotesShell, {
      subtitle: rows && rows.length ? `${rows.length} order request${rows.length === 1 ? "" : "s"} · the ERP reports status through the ingest API; the dealer sees the same timeline on the portal` : "Accepted quotes handed to the ERP, with the status it reports back",
      chips: [lastReport ? {
        k: "ERP",
        v: `last report ${relTime(lastReport)}`
      } : null],
      actions: /*#__PURE__*/React.createElement(Btn, {
        primary: true,
        onClick: () => this.props.history.push("/Quotes/new")
      }, "New quote")
    }, notice ? /*#__PURE__*/React.createElement(Notice, {
      tone: notice.tone,
      onClose: () => this.setState({
        notice: null
      })
    }, notice.text) : null, rows === undefined ? /*#__PURE__*/React.createElement(Loader, null) : rows === null ? /*#__PURE__*/React.createElement("div", {
      className: "wa-grid"
    }, /*#__PURE__*/React.createElement(Card, {
      title: "Order requests"
    }, /*#__PURE__*/React.createElement("p", {
      className: "territory-hint",
      style: {
        margin: 0
      }
    }, "Order requests are not available yet for this workspace. Accepted quotes appear here once the desk's rail is enabled."))) : /*#__PURE__*/React.createElement("div", {
      className: "wa-grid"
    }, /*#__PURE__*/React.createElement(Card, {
      span: 7,
      title: "Order requests",
      hint: `${list.length} of ${rows.length} · click a request for its timeline`
    }, /*#__PURE__*/React.createElement("div", {
      className: "wa-toolbar"
    }, /*#__PURE__*/React.createElement("span", {
      className: "qt-chips"
    }, ORDER_STATUSES.filter(([k]) => counts[k] || k === "pending_erp").map(([k, l]) => /*#__PURE__*/React.createElement("button", {
      key: k,
      type: "button",
      className: `wa-chip${chip === k ? " on" : ""}`,
      onClick: () => this.setState({
        chip: chip === k ? "all" : k
      })
    }, /*#__PURE__*/React.createElement("span", {
      className: "k"
    }, l), " ", counts[k] || 0))), /*#__PURE__*/React.createElement(Filters, null, /*#__PURE__*/React.createElement(PlunkDropDown, {
      width: "180px",
      value: dealer,
      onChange: v => this.setState({
        dealer: v
      }),
      options: [["", "Dealer: all"], ...dealers]
    }), /*#__PURE__*/React.createElement(Search, {
      value: q,
      onChange: v => this.setState({
        q: v
      }),
      placeholder: "Search request, PO, ERP order"
    }))), list.length === 0 ? /*#__PURE__*/React.createElement(Empty, null, rows.length === 0 ? "No order requests yet. A dealer's acceptance on the quote link, or Convert on a quote, creates the first one." : "No requests match these filters.") : /*#__PURE__*/React.createElement("div", {
      className: "tblwrap"
    }, /*#__PURE__*/React.createElement("table", {
      className: "territory-table wa-table qt-table"
    }, /*#__PURE__*/React.createElement("thead", null, /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("th", null, "Request"), /*#__PURE__*/React.createElement("th", null, "Dealer"), /*#__PURE__*/React.createElement("th", null, "ERP order"), /*#__PURE__*/React.createElement("th", null, "Status"), /*#__PURE__*/React.createElement("th", {
      className: "n"
    }, "Net"), /*#__PURE__*/React.createElement("th", {
      className: "n"
    }, "Last report"))), /*#__PURE__*/React.createElement("tbody", null, list.map(r => /*#__PURE__*/React.createElement("tr", {
      key: r.id,
      className: `clickable${sel && sel.id === r.id ? " on" : ""}`,
      onClick: () => this.open(r)
    }, /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement("span", {
      className: "name"
    }, r.number || `Request ${r.id}`), /*#__PURE__*/React.createElement("span", {
      className: "code"
    }, [r.quoteNumber ? `from ${r.quoteNumber}` : r.source !== "quote" ? r.source.replace(/_/g, " ") : null, this.noteFor(r)].filter(Boolean).join(" · "))), /*#__PURE__*/React.createElement("td", null, r.customerName || r.customerId), /*#__PURE__*/React.createElement("td", null, r.erpOrderId || /*#__PURE__*/React.createElement("span", {
      className: "dim"
    }, "waiting")), /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(Pill, {
      tone: this.stuck(r) ? "danger" : orderStatusTone(r.status)
    }, orderStatusLabel(r.status))), /*#__PURE__*/React.createElement("td", {
      className: "n"
    }, money0(r.totalNet)), /*#__PURE__*/React.createElement("td", {
      className: "n"
    }, fmtDate(r.statusDate || r.modifiedDate || r.createdDate, false) || "—")))))), /*#__PURE__*/React.createElement("p", {
      className: "wa-foot"
    }, "Requests still Pending ERP after two business days are flagged. Unknown ERP status values are shown as the ERP sent them.")), /*#__PURE__*/React.createElement(Card, {
      span: 5,
      title: sel ? `${sel.number || "Request"} · ${sel.customerName || sel.customerId}${sel.erpOrderId ? ` · ${sel.erpOrderId}` : ""}` : "Timeline",
      hint: sel && sel.quoteNumber ? /*#__PURE__*/React.createElement(Link, {
        to: sel.quoteId ? `/Quotes/${encodeURIComponent(sel.quoteId)}` : "/Quotes"
      }, "open ", sel.quoteNumber) : undefined,
      right: canCancel ? /*#__PURE__*/React.createElement("a", {
        className: "wa-rowlink danger",
        onClick: () => this.setState({
          modal: "cancel",
          cancelReason: ""
        })
      }, "Cancel request") : null
    }, !sel ? /*#__PURE__*/React.createElement(Empty, null, "Pick a request to see the ERP timeline.") : /*#__PURE__*/React.createElement(React.Fragment, null, this.timeline(sel), selBusy ? /*#__PURE__*/React.createElement("p", {
      className: "territory-hint"
    }, "Loading the status events\u2026") : null, sel.lines && sel.lines.length ? /*#__PURE__*/React.createElement("div", {
      className: "tblwrap",
      style: {
        marginTop: 10
      }
    }, /*#__PURE__*/React.createElement("table", {
      className: "territory-table wa-table"
    }, /*#__PURE__*/React.createElement("thead", null, /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("th", null, "Line"), /*#__PURE__*/React.createElement("th", {
      className: "n"
    }, "Qty"), /*#__PURE__*/React.createElement("th", {
      className: "n"
    }, "Extended"))), /*#__PURE__*/React.createElement("tbody", null, sel.lines.map((l, i) => /*#__PURE__*/React.createElement("tr", {
      key: l.id || i
    }, /*#__PURE__*/React.createElement("td", {
      className: "wrap"
    }, /*#__PURE__*/React.createElement("span", {
      className: "name"
    }, l.title || l.productId), /*#__PURE__*/React.createElement("span", {
      className: "code"
    }, l.configText || l.sku || l.productId)), /*#__PURE__*/React.createElement("td", {
      className: "n"
    }, l.quantity), /*#__PURE__*/React.createElement("td", {
      className: "n"
    }, money(l.extended))))))) : null, /*#__PURE__*/React.createElement("p", {
      className: "wa-foot"
    }, [sel.poNumber ? `PO ${sel.poNumber}` : null, sel.requestedDate ? `requested ship ${fmtDate(sel.requestedDate)}` : null, sel.repCode ? `rep ${sel.repCode}` : null, sel.statusDate ? `last report ${fmtDateTime(sel.statusDate)}` : null].filter(Boolean).join(" · ") || "No PO or ship date on this request.")))), modal === "cancel" && sel ? /*#__PURE__*/React.createElement(Modal, {
      title: `Cancel ${sel.number || "request"}`,
      width: 440,
      onClose: () => this.setState({
        modal: null
      }),
      busy: busy,
      footer: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Btn, {
        onClick: () => this.setState({
          modal: null
        })
      }, "Keep"), /*#__PURE__*/React.createElement(Btn, {
        danger: true,
        disabled: !cancelReason.trim() || busy,
        onClick: this.cancel
      }, "Cancel request")),
      note: "possible before the ERP acknowledges; after that, cancel in the ERP"
    }, /*#__PURE__*/React.createElement("div", {
      className: "ec-field"
    }, /*#__PURE__*/React.createElement("label", null, "Reason"), /*#__PURE__*/React.createElement("input", {
      className: "ec-input",
      autoFocus: true,
      value: cancelReason,
      onChange: e => this.setState({
        cancelReason: e.target.value
      })
    }))) : null));
  }
}
export default withRouter(OrdersView);